import { i18n } from '@/plugins/i18n';
import type { RouteLocationNormalized } from 'vue-router';

// index.htmlの<title>は全国共通のため、ロケール確定後にルートごとの表示名で上書きする
/** Fallback used for routes without their own title (e.g. /login) */
const APP_TITLE_KEY = 'header.accountManagement';

/** Localized browser tab title for the given route */
export function resolvePageTitle(route: RouteLocationNormalized): string {
  return i18n.global.t(route.meta.titleKey ?? APP_TITLE_KEY);
}
